import { FC } from 'react';
import { Divider } from '@chakra-ui/react';

import IconButton from 'components/_core/IconButton';
import Text from 'components/_core/Text';
import { PPatp } from 'helpers/date';
import { getDeviceInformation } from 'helpers/device';

import {
  getDeviceLastActivityFormattedDate,
  getDeviceLocation,
  isDeviceBlocked,
  isDeviceTrusted,
} from '../../../../helpers';
import DeviceStatusBadge from '../../../DeviceStatusBadge';
import { Step } from '../../types';
import Action from './components/Action';
import locales from './locales';
import * as S from './styles';
import { Props } from './types';

const DeviceDetails: FC<Props> = ({ close, device, setStep }) => {
  const lastActivityDate = getDeviceLastActivityFormattedDate(device, PPatp);

  const currentDevice = getDeviceInformation();
  const isCurrentDevice = currentDevice.token === device.token;

  const location = getDeviceLocation(device);

  return (
    <>
      <S.Header>
        <IconButton
          aria-label=""
          icon="cross"
          onClick={close}
          variant="secondary"
        />
      </S.Header>

      <S.Body>
        <S.DetailsHeader>
          <S.Title>{device.name}</S.Title>
          {lastActivityDate ? (
            <Text>
              {locales.lastActivity} • {lastActivityDate}
            </Text>
          ) : null}
        </S.DetailsHeader>

        <S.Properties>
          <S.Property>
            <S.PropertyLabel>{locales.currentStatus}</S.PropertyLabel>
            <DeviceStatusBadge device={device} />
          </S.Property>

          <S.Property>
            <Divider />
          </S.Property>

          {location ? (
            <S.Property>
              <S.PropertyLabel>{locales.location}</S.PropertyLabel>
              <S.PropertyValue>{location}</S.PropertyValue>
            </S.Property>
          ) : null}
        </S.Properties>
      </S.Body>

      {isDeviceTrusted(device) && !isCurrentDevice ? (
        <S.Actions>
          <Action
            description={locales.blockThisDeviceDescription}
            icon="lock"
            onClick={() => setStep(Step.BLOCK)}
            title={locales.blockThisDevice}
          />
        </S.Actions>
      ) : null}

      {isDeviceBlocked(device) && !isCurrentDevice ? (
        <S.Actions>
          <Action
            description={locales.unblockThisDeviceDescription}
            icon="unlock"
            onClick={() => setStep(Step.UNBLOCK)}
            title={locales.unblockThisDevice}
          />
        </S.Actions>
      ) : null}
    </>
  );
};

export default DeviceDetails;
